export enum Unit {
  G = 'G',

  KG = 'KG',

  ML = 'ML',

  L = 'L',
}

export interface Product {
  id: string;

  name: string;

  description?: string;

  targetQuantity: number;

  unit: Unit;

  densityGMl?: number;

  tareWeightG?: number;
}
